import { API_ENDPOINT } from "@/constants/appConstants";

export type AutoApplyPayload = {
  data: any;
};

export const autoApplyPostFunc = async (payload: AutoApplyPayload) => {
  try {
    const host = window.location.host;

    const response = await fetch(API_ENDPOINT(host).middleware.autoApplyV2, {
      method: "POST",
      // headers: {
      //   "Content-Type": "application/json",
      // },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.log(`API failed with status ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};
